import React from 'react';
import {
  FontSizeChange,
  SetIFrameId,
  SetLanguageId,
  SetScrollingMargin,
  SetComparePagePlans,
} from './postMessages';

export default function AllPostMessages() {
  return (
    <React.Fragment>
      <FontSizeChange />
      <SetIFrameId />
      <SetLanguageId />
      <SetScrollingMargin />
      <SetComparePagePlans />
    </React.Fragment>
  );
}
